import { postData } from './http';

let promise;

export function getStats(statsRequest) {
    if (promise) {
        return promise;
    }

    statsRequest.CultureCode = TRPCONFIG.Domain.CultureCode;
    statsRequest.TenantId = TRPCONFIG.Domain.TenantId;
    promise = postData('/api2/publicity/getstats', statsRequest, { logErrors: false });
    return promise;
}
